var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-date-picker", {
    staticStyle: { width: "100%" },
    attrs: {
      disabled: _vm.disabled,
      clearable: "",
      type: "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      placeholder: "选择日期",
    },
    on: { change: _vm.valueChange },
    model: {
      value: _vm.dataValue,
      callback: function ($$v) {
        _vm.dataValue = $$v
      },
      expression: "dataValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }